import { createFileRoute } from '@tanstack/react-router'

import ApbdPage from '@/components/pages/backoffice/_ktg-penyuluh/apbn-apbd/containers/ApbdPage'

export const Route = createFileRoute('/_backoffice/ktg-penyuluh/apbd/')({
  component: ApbdPage
})
